var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSwitch = function SvgIconSwitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 6,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.556 5.3V.7a.376.376 0 0 1 .37-.367q.108 0 .2.058L2.96 1.553a.37.37 0 0 1 .179.313v2.267a.37.37 0 0 1-.18.313L1.127 5.608a.37.37 0 0 1-.57-.308m4.26-.34V1.027a.36.36 0 0 1 .219-.334.37.37 0 0 1 .398.061l.965.833a.37.37 0 0 1 .125.274v2.266a.36.36 0 0 1-.125.275l-.965.832a.372.372 0 0 1-.617-.273M8.2 4.621V1.355a.36.36 0 0 1 .233-.341.37.37 0 0 1 .406.089l.491.487a.37.37 0 0 1 .115.265v2.267a.36.36 0 0 1-.115.264l-.491.487a.371.371 0 0 1-.64-.251"
  })));
};
export default SvgIconSwitch;